import type { Inquiry } from '@mathflat/domain/Inquiry'
import { format } from 'date-fns'
import koLocale from 'date-fns/locale/ko'
import { computed, makeObservable, observable } from 'mobx'

import { EMPTY_NUMBER_ID } from '@/constant/common'

import { DTO } from '../DTO'

export class Qna extends DTO implements Inquiry {
  id = EMPTY_NUMBER_ID
  solved = false
  questionType: Inquiry['questionType'] = 'CONTENT'
  questionDate = ''
  questionTitle = ''
  questionContent = ''
  replyContent: Inquiry['replyContent'] = null
  replyDate: Inquiry['replyDate'] = null
  attachments: Inquiry['attachments'] = null

  constructor(data?: Inquiry) {
    super()

    makeObservable(this, {
      id: observable,
      solved: observable,
      questionType: observable,
      questionDate: observable,
      questionTitle: observable,
      questionContent: observable,
      replyContent: observable,
      replyDate: observable,
      attachments: observable,
      korTag: computed,
    })

    if (data) this.update<Qna>(data)
  }

  get korTag() {
    switch (this.questionType) {
      case 'CONTENT':
        return '문제은행'
      case 'FUNCTION_BUG':
        return '기능오류'
      case 'FUNCTION_INQUIRY':
        return '기능문의'
      case 'FAQ':
        return 'FAQ수정'
      case 'ETC':
        return '기타문의'
    }
  }

  get formattedReplyDate() {
    if (this.replyDate) {
      return format(new Date(this.replyDate), 'yyyy.MM.dd a hh:mm', { locale: koLocale })
    }
  }

  get formattedQuestionDate() {
    return format(new Date(this.questionDate), 'yyyy.MM.dd a hh:mm', { locale: koLocale })
  }
}
